import { CTAButton } from "lib/components/CTAButton";
import { CheckboxButton } from "lib/components/Checkbox";
import { KeyValue } from "lib/components/KeyValue";
import { fetchData } from "lib/helpers/fetchData";
import { getApiUrl } from "lib/helpers/getApiUrl";
import { getFormValues } from "lib/helpers/getFormValues";
import { StyledForm } from "lib/styles/general";
import { useRef, useState, useEffect } from "react";

export const QueryEngine = ({ customerId, reload }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [queryEngineStatus, setQueryEngineStatus] = useState(null);
  const formRef = useRef(null);

  useEffect(() => {
    const fetchQueryEngineStatus = async () => {
      try {
        const response = await fetchData(`${getApiUrl("QUERY_ENGINE_API")}/customers/${customerId}`);
        if (response?.queryEngine?.enabled !== undefined) {
          setQueryEngineStatus(response.queryEngine.enabled); 
        }
      } catch (error) {
        console.error("Error fetching query engine status:", error);
      }
    };

    if (customerId) {
      fetchQueryEngineStatus();
    }
  }, [customerId]);

  const handleSubmit = async () => {
    setIsLoading(true);
    let { enabled } = getFormValues(formRef.current);
    const requestBody = JSON.stringify({
      queryEngine: { enabled }
    });
    await fetchData(`${getApiUrl("QUERY_ENGINE_API")}/customers/${customerId}/query-engine`, requestBody, "PATCH");
    setQueryEngineStatus(enabled);
    setIsLoading(false);
    setIsEditMode(false);
    reload();
  };

  const handleExit = () => setIsEditMode(false);

  return (
    <div style={{ position: "relative" }}>
      <div style={{ marginBottom: '1rem', fontSize: '14px' }}>
        <p><strong>Configures whether a customer can be queried via the Workbench Query Engine.</strong></p>
        <p>
        This option should only be enabled for customers using <strong>Microsoft Defender</strong> security logs. When enabled, the customer will appear as an option within the Workbench Query Engine, allowing a user to run queries against them.
        </p>
      </div>

      <StyledForm ref={formRef}>
        <section style={{ paddingTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <KeyValue
            text="Service Status"
            wrap={false}
            value={
              <CheckboxButton
                name="enabled"
                subtle
                showWhenNull
                label={!isEditMode ? (queryEngineStatus ? "Enabled" : "Disabled") : "Is Enabled?"}
                defaultChecked={queryEngineStatus}
                readOnly={!isEditMode}
              />
            }
          />
          {!isEditMode && (
            <CTAButton onClick={() => setIsEditMode(!isEditMode)}>
              Edit
            </CTAButton>
          )}
        </section>
      </StyledForm>
      {isEditMode && (
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1rem" }}>
          <CTAButton isSecondary onClick={handleExit}>
            Cancel
          </CTAButton>
          <CTAButton isLoading={isLoading} onClick={handleSubmit}>
            Save
          </CTAButton>
        </div>
      )}
    </div>
  );
};
